import { FC } from 'react';
import { useIntl } from 'react-intl';
import { PageTitle } from '../../../_metronic/layout/core';
import { TachoOrderForm } from '../../modules/tacho-orders';

const TachoOrderCreatePage: FC = () => {
  const intl = useIntl();

  return (
    <>
      <PageTitle>
        {intl.formatMessage({ id: 'tachoOrders.createTitle' })}
      </PageTitle>
      <TachoOrderForm mode="create" />
    </>
  );
};

export { TachoOrderCreatePage };
